<template>
  <div class="header-box">
    <div class="header-left">
      <div class="text icon-text-center"
           :class="{'en-font': $i18n.locale == 'en'}">
        <el-link href="https://www.mktindex.com/static/pricing/?f=jingjie"
                 target="_blank"
                 style="color: #1D2043;"
                 :underline="false">
          <!-- <div class="icon-text-center pro-price"
               @mouseover="priceHover = true"
               @mouseleave="priceHover = false">
            <img :src="priceHover ? priceHoverPic : pricePic"
                 alt=""
                 style="width: 18px; height: 18px;margin-right: 5px"> 全部产品定价
          </div> -->
        </el-link>
      </div>
    </div>
    <div class="header-right">
      <div class="icon-text-center"
           style="cursor: pointer;"
           v-if="!isJdUser"
           @click="showPayDialog">
        <el-button size="mini"
                   class="shop-btn">
          <div style="display: flex; justify-content: center; align-items: center;height: 20px; line-height: 20px;font-size: 14px">
            <img src="../assets/img/shop.svg"
                 alt=""
                 style="width: 18px;height: 18px;margin-right: 5px
               ">
            购买套餐
          </div>
        </el-button>

      </div>
      <!-- <div style="margin-left: 10px">
        <el-button size="mini"
                   class="invite-btn"
                   @click="jumpToInvite">
          <div style="display: flex; justify-content: center; align-items: center;height: 20px; line-height: 20px;font-size: 14px">
            <i class="el-icon-present"
               style="font-size: 16px;margin-right: 5px"></i>
            邀请有礼
          </div>
        </el-button>
      </div> -->

      <userinfo @userLogin="userLoginValue"> </userinfo>
    </div>
    <el-dialog :visible.sync="showMiniDialog"
               append-to-body
               custom-class="mini-dialog"
               :show-close="false"
               width="560px">
      <div class="mini-dialog-area">
        <div class="title-area">
          <span class="blue-label"></span><span>魔镜洞察 增长雷达</span>
          <div style="position: relative;"><span class="aqua-label">Lite</span></div> <span>全新上线!</span>
        </div>
        <div class="sub-title-area">
          <span>海内外高增概念/品类/品牌一站式查看！</span>
          <span>老板再也不用担心我错过热点！</span>
        </div>
        <div class="content-area">
          <div class="content-left">
            <img src="../assets/img/QRcode-www2.png"
                 style="width: 140px;"
                 alt="">
            <span class="yellow-tips">微信扫码立即使用</span>
          </div>
          <div class="content-right">
            <span class="yellow-big-tips">免费版</span>
            <span>领先对手6个月发现新机会</span>
            <span>正在疯涨的品类都给你整理好了！</span>
          </div>
        </div>
        <div class="side-img">
          <img src="../assets/img/png-2.png"
               alt="">
        </div>
      </div>

    </el-dialog>
  </div>
</template>

<script>
import userinfo from '@/components/userinfo.vue'
export default {
  components: {
    userinfo,
  },
  data() {
    return {
      loginInfo: {},
      showMiniDialog: false,
      priceHover: false,
      pricePic: require('../assets/img/price-center.svg'),
      priceHoverPic: require('../assets/img/price-hover.png'),
    }
  },
  methods: {
    jumpToInvite() {
      if (Object.keys(this.loginInfo).length == 0) {
        this.$eventBus.$emit('showLoginDialog')
        return
      }
      this.$eventBus.$emit('jumpToInvite')
    },
    userLoginValue(val) {
      this.loginInfo = val
      this.$store.dispatch('user/changeLoginInfo', this.loginInfo)
    },
    showPayDialog() {
      if (Object.keys(this.loginInfo).length == 0) {
        this.$eventBus.$emit('showLoginDialog')
        return
      }
      this.$eventBus.$emit('showPayDialog', 'Home-page')
    },
  },
  computed: {
    isJdUser() {
      return this.$store.state.user.isJdUser
    },
  },
  watch: {},
  created() {},
}
</script>

<style scoped lang='less'>
.header-box {
  background-color: #f4f5fa;
}
.header-left {
  color: #fff;
  .lb {
    display: inline-block;
  }

  .kf {
    margin-left: 30px;
    cursor: pointer;
    line-height: 56px;
    font-size: 20px;
  }
  .text {
    display: inline-block;
    font-size: 14px;
    vertical-align: top;
    margin-left: 4px;
  }
}
.header-right {
  font-size: 14px;
  font-family: inherit;
  color: #1d2043;
  .el-dropdown-link {
    color: #1d2043;
  }
}
.header-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  .shop-btn {
    border-radius: 5px;
    background-color: #2f4eff;
    color: white;
    height: 30px;
    line-height: 30px;
    padding: 0px 15px;
    font-weight: 400;
  }
  .shop-btn:hover {
    background-color: #5770ff;
  }
  .invite-btn {
    border-radius: 5px;
    background-color: #b43523;
    color: white;
    height: 30px;
    line-height: 30px;
    padding: 0px 15px;
    font-weight: 400;
  }
  .pro-price:hover {
    color: #2f4eff;
  }

  .icon-text-center {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 20px;
    line-height: 20px;
    letter-spacing: 1px;
  }

  .header-right {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .headText {
      font-size: 14px;
      color: #1d2043;
    }

    .select {
      display: flex;

      .typeSearch {
        .el-input__inner {
          width: 115px;
          background: #3a63f3;
          color: white;
          border: 1px solid #3a63f3;

          .el-input .el-select__caret {
            color: white;
          }
        }
      }

      .el-select {
        .el-input--small .el-input__inner {
          border-bottom-left-radius: 0 !important;
          border-top-left-radius: 0 !important;
        }
      }

      .el-input-group--append .el-input__inner {
        border-radius: 0;
      }

      .el-input-group__append {
        //background: #3A63F3;
        .el-button {
          i {
            color: #3a63f3;
          }
        }
      }
    }

    .myAtention {
      margin-left: 50px;
    }

    .user {
      margin-left: 30px;
      display: flex;
      justify-content: right;
      align-items: center;

      .personIcon {
        font-size: 15px;
        margin-right: 5px;
        color: #fff;
        vertical-align: text-bottom;
      }
    }

    .language {
      margin-left: 50px;
      justify-content: right;
      align-items: center;
      color: #fff;

      span {
        cursor: pointer;

        &.selected {
          color: #fff;
        }
      }
    }
  }
}
.iconfont {
  font-family: 'iconfont' !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
}
</style>
<style lang='less'>
.el-header {
  background-color: #f4f5fa;
  padding: 0 10px;
}
.mini-dialog {
  font-family: inherit;
  border-radius: 15px !important;
  .el-dialog__header {
    padding: 0;
  }
  .title-area {
    height: 28px;
    display: flex;
    align-items: center;

    font-size: 24px;
    .blue-label {
      display: inline-block;
      width: 7px;
      height: 24px;
      background-color: #6577f6;
      border-radius: 4px;
      margin-right: 5px;
    }
    .aqua-label {
      display: inline-block;
      vertical-align: top;
      text-align: center;
      color: #ffffff;
      font-size: 17px;
      width: 36px;
      height: 18px;
      line-height: 18px;
      background-color: #22e0ec;
      border-radius: 3px;
    }
  }
  .sub-title-area {
    padding: 20px 0px 0px 30px;
    font-size: 16px;
    color: #939393;
    line-height: 20px;
    display: flex;
    flex-direction: column;
    span {
      margin-bottom: 2px;
    }
  }
  .content-area {
    display: flex;
    margin-top: 20px;
    margin-left: 20px;
    .content-left {
      display: flex;
      flex-direction: column;
      .yellow-tips {
        text-align: center;
        font-size: 16px;
        font-weight: bold;
        color: #ffffff;
        background-color: #ffb234;
        margin-top: 10px;
      }
    }
    .content-right {
      display: flex;
      flex-direction: column;
      margin-left: 20px;
      span {
        height: 30px;
        font-weight: 500;
        color: #242424;
        font-size: 17px;
        line-height: 30px;
      }
      .yellow-big-tips {
        text-align: center;
        width: 110px;
        height: 30px;
        line-height: 30px;
        color: #ffffff;
        font-size: 20px;
        font-weight: bold;
        background-color: #ffb234;
        border-radius: 3px;
        margin-top: 10px;
        margin-bottom: 10px;
      }
    }
  }
  .side-img {
    position: absolute;
    top: 45px;
    right: 30px;
    img {
      width: 90px;
      height: 180px;
    }
  }
}
</style>
